/**
 * State used in rendering MessageBarActions
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
